import React, { useContext, useEffect, useState } from 'react';
import { HashRouter, Link, Route, Switch, useLocation } from 'react-router-dom';
import { userContext } from '../../../contextProvider/Authentication';
import axiosInstance from '../../../services/AxiosInstance';
import FileUpload from '../../Element/FileUpload';
import userImg from '../../../images/defaultuserimage.jpg';
import { getBase64 } from '../../../Functions/apis';
import swal from 'sweetalert';
import Companyprofile from './Profile/ConCompanyprofile';
import SubUsers from './SubUsers/SubUsers';
import CompanyPostJobs from './Jobs/ConCompanyPostJobs';
import Companymanage from './Jobs/PostedJobsandAppliedCandidates/PostedJobs';
import Companytransactions from './Companytransactions';
import Workflow from './WorkFlow/Dashboard';
import PasswordChange from './Changepasswordpage';
import Candidates from './Jobs/PostedJobsandAppliedCandidates/Candidates';

const Layout = () => {
    let { pathname } = useLocation();

    const { user, authenticated } = useContext(userContext);

    const [profileupdated, setProfileupdated] = useState(false);
    const [pimg, setPimg] = useState(() => {
        if (authenticated) {
            return localStorage.getItem('pimg');
        } else return null;
    });

    useEffect(() => {
        axiosInstance(
            "user/has_profile/", {
            method: "GET",
            data: {}
        }).then(res => {
            setProfileupdated(res.data.has_profile);
        })
    }, []);

    const handleImageChange = e => {
        let file = e.target.files[0];
        if (file.size < 1024000) {
            getBase64(file)
                .then(result => {
                    axiosInstance(`/user/${user?.id}/`, { method: "PATCH", data: { "pimg": result } });
                    localStorage.setItem("pimg", result);
                    setPimg(result);
                })
        }
        else swal("", "The Image size should be less than 1mb", "error", { button: "Ok!", })
    }
    return (
        <div className="page-content bg-white">
            <div className="content-block">
                <div className="section-full bg-white browse-job p-t50 p-b20">
                    <div className="ml-5 mr-5">
                        <div className="row">
                            {/* Sidebar start */}
                            <div className="col-xl-3 col-lg-4 m-b30">
                                <div className="sticky-top">
                                    <div className="candidate-info company-info">
                                        <div className="candidate-detail text-center">
                                            <div className="canditate-des">
                                                <Link to={"#"}>
                                                    <img alt="" src={pimg ? pimg : userImg} />
                                                </Link>
                                                <div className="upload-link" title="update" data-toggle="tooltip" data-placement="right">
                                                    <FileUpload
                                                        url={`/user/${user?.id}/`}
                                                        className="update-flie"
                                                        handleChange={handleImageChange}
                                                    />
                                                    <i className="fa fa-pencil"></i>
                                                </div>
                                            </div>
                                            <div className="candidate-title">
                                                <h4 className="m-b5"><Link to={"#"}>{user?.first_name}</Link></h4>
                                            </div>
                                        </div>
                                        <ul>
                                            <li><Link to={"/employer/company-profile"} className={pathname === '/employer/company-profile' ? 'active' : ''}>
                                                <i className="fa fa-user-o" aria-hidden="true"></i>
                                                <span>Company Profile</span></Link></li>
                                        </ul>
                                        <ul className={!profileupdated ? 'custom-disabled' : ''}>
                                            <li><Link to={"/employer/sub-users"} className={pathname === '/employer/sub-users' ? 'active' : ''}>
                                                <i className="fa fa-users" aria-hidden="true"></i>
                                                <span>Users</span></Link></li>
                                            <li><Link to={"/employer/company-post-jobs"} className={pathname === '/employer/company-post-jobs' ? 'active' : ''}>
                                                <i className="fa fa-file-text-o" aria-hidden="true"></i>
                                                <span>Post Job</span></Link></li>
                                            <li><Link to={"/employer/company-manage-job"} className={pathname === '/employer/company-manage-job' ? 'active' : ''}>
                                                <i className="fa fa-briefcase" aria-hidden="true"></i>
                                                <span>Manage jobs</span></Link></li>
                                            <li><Link to={"/employer/company-transactions"} className={pathname === '/employer/company-transactions' ? 'active' : ''}>
                                                <i className="fa fa-random" aria-hidden="true"></i>
                                                <span>Transactions</span></Link></li>
                                            {/* <li><Link to={"/company-resume"} className={activeMenu === 'resume' && 'active'}>
                                                <i className="fa fa-id-card-o" aria-hidden="true"></i>
                                                <span>Resume</span></Link></li> */}
                                            <li><Link to={"/employer/work-flow"} className={pathname === '/employer/work-flow' ? 'active' : ''}>
                                                <i className="fa fa-id-card-o" aria-hidden="true"></i>
                                                <span>Workflow</span></Link></li>
                                            {/* <li><Link to={"/browse-candidates"} className={activeMenu === 'browsecandidate' ? 'active' : ''}>
                                                <i className="fa fa-id-card-o" aria-hidden="true"></i>
                                                <span>Browse Candidates</span></Link></li> */}
                                            <li><Link to={"/employer/employer-change-password"} className={pathname === '/employer/employer-change-password' ? 'active' : ''}>
                                                <i className="fa fa-key" aria-hidden="true"></i>
                                                <span>Change Password</span></Link></li>
                                            {/* <li><Link to={"/employer-feedback"} className={activeMenu === 'empfeedback' ? 'active' : ''}>
                                                <i className="fa fa-comments-o" aria-hidden="true"></i>
                                                <span>Employer Feedback</span></Link></li> */}
                                            <li><Link to={"./"}>
                                                <i className="fa fa-sign-out" aria-hidden="true"></i>
                                                <span>Log Out</span></Link></li>
                                        </ul>
                                    </div>
                                </div>
                            </div >
                            {/* Sidebar end */}
                            <div className="col-xl-9 m-b30">
                                <HashRouter>
                                    <Switch>
                                        <Route
                                            path="/employer/company-profile"
                                            exact={true}
                                            component={Companyprofile}
                                        />
                                        <Route
                                            path="/employer/sub-users"
                                            exact={true}
                                            component={SubUsers}
                                        />
                                        <Route
                                            path="/employer/company-post-jobs/:id?"
                                            exact={true}
                                            component={CompanyPostJobs}
                                        />
                                        <Route
                                            path="/employer/company-manage-job"
                                            exact={true}
                                            component={Companymanage}
                                        />
                                        <Route
                                            path="/employer/company-transactions"
                                            exact={true}
                                            component={Companytransactions}
                                        />
                                        <Route
                                            path="/employer/work-flow"
                                            exact={true}
                                            component={Workflow}
                                        />
                                        <Route
                                            path="/employer/employer-change-password"
                                            exact={true}
                                            component={PasswordChange}
                                        />
                                        <Route
                                            path="/employer/emp-candidates/:jobId?"
                                            exact={true}
                                            component={Candidates}
                                        />
                                    </Switch>
                                </HashRouter>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Layout;